<template>
  <DashboardPanel title="楼栋收费排行（TOP5）" meta="单位：元">
    <div ref="chart" class="ranking-chart"></div>
  </DashboardPanel>
</template>
<script>
import * as echarts from 'echarts'
import DashboardPanel from './DashboardPanel.vue'
import { dashboardTooltip, formatNumber, formatPercent, roundNumber } from '../dashboardFormat'

export default {
  name: 'BuildingRanking',
  components: { DashboardPanel },
  props: { data: { type: Object, default: () => ({}) } },
  data: () => ({ chart: null }),
  computed: {
    ranking() {
      return (Array.isArray(this.data.floorRanking) ? this.data.floorRanking : []).slice(0, 5)
    }
  },
  watch: { data: { deep: true, handler() { this.renderChart() } } },
  mounted() {
    this.renderChart()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    renderChart() {
      if (!this.chart) this.chart = echarts.init(this.$refs.chart)
      const rows = this.ranking.map(item => ({
        name: this.floorName(item),
        value: roundNumber(item.receivedAmount, 2),
        receivableAmount: roundNumber(item.receivableAmount, 2)
      }))
      this.chart.setOption({
        grid: { top: 12, right: 16, bottom: 58, left: 54 },
        tooltip: dashboardTooltip({
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: params => {
            const item = (Array.isArray(params) ? params[0] : params) || {}
            const row = item.data || {}
            return `${echarts.format.encodeHTML(item.name || '-')}<br/>${item.marker || ''}实收金额：${formatNumber(row.value, 2)} 元<br/>应收金额：${formatNumber(row.receivableAmount, 2)} 元<br/>缴费率：${formatPercent(row.value, row.receivableAmount)}`
          }
        }),
        xAxis: {
          type: 'category',
          data: rows.map(item => item.name),
          axisTick: { show: false },
          axisLine: { lineStyle: { color: '#36586d' } },
          axisLabel: { color: '#d9e6ef', fontSize: 10, interval: 0, rotate: 28, margin: 12, overflow: 'truncate', width: 82 }
        },
        yAxis: {
          type: 'value',
          min: 0,
          splitNumber: 4,
          axisLine: { show: false },
          axisLabel: { color: '#879eae', fontSize: 9, formatter: value => formatNumber(value) },
          splitLine: { lineStyle: { color: 'rgba(67, 122, 157, .14)', type: 'dashed' } }
        },
        series: [{
          name: '实收金额',
          type: 'bar',
          barMaxWidth: 24,
          data: rows,
          itemStyle: { color: '#2f88ed' },
          label: { show: true, position: 'top', color: '#e7f0f7', fontSize: 9, formatter: params => formatNumber(params.value) }
        }]
      }, true)
    },
    floorName(item) {
      const rawFloor = item.floorNum || item.floorId
      const floor = rawFloor
        ? (/[栋楼座幢]$/.test(String(rawFloor)) ? String(rawFloor) : `${rawFloor}栋`)
        : '-'
      return item.communityName ? `${item.communityName}-${floor}` : floor
    },
    resizeChart() { if (this.chart) this.chart.resize() }
  }
}
</script>
<style scoped>.ranking-chart{width:100%;height:100%;}</style>
